import {
  Link,
  useOutletContext,
  useParams,
  useNavigate,
  useNavigationType,
  useLocation
} from "react-router-dom";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import { useEffect, useState, useRef } from "react";
import { getTradingSingleVideos, incrementSingleView, incrementView } from "../api/user";

const TradingSingle = () => {
  const [sidebarToggle] = useOutletContext();
  const { id,category_id } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);
  const [otherVideos, setOtherVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const navigationType = useNavigationType();


useEffect(() => {
  const fetchVideoDetails = async () => {
    try {
      setLoading(true);
      const response = await getTradingSingleVideos({ category_id: category_id });
      const videos = response.data.videos || [];

      // Find the selected video
      const selectedVideo = videos.find((v) => v.id.toString() === id);

      if (selectedVideo) {
        setVideo(selectedVideo);

        // Filter videos that belong to the same category
        const relatedVideos = videos.filter(
          (v) => v.category_id === selectedVideo.category_id && v.id.toString() !== id
        );

        setOtherVideos(relatedVideos);
      } else {
        setOtherVideos([]); // No related videos if no video is found
      }
    } catch (error) {
      console.error("Failed to fetch video details:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchVideoDetails();
}, [id]);

  useEffect(() => {
    if (videoRef.current) {
      if (navigationType === "PUSH") {
        // Coming from parent: Auto-play video
        videoRef.current
          .play()
          .catch((err) => console.log("Autoplay failed", err));
      } else {
        // Refresh case: Ensure first click plays the video
        const enablePlayback = () => {
          videoRef.current.play();
          document.removeEventListener("click", enablePlayback);
        };
        document.addEventListener("click", enablePlayback);
      }
    }
  }, [navigationType]);

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      const options = { day: "2-digit", month: "long", year: "numeric" };
      return date.toLocaleDateString("en-GB", options);
    };

const handleVideoView = async (id) => {
  try {
    await incrementSingleView({id:id});
    console.log(`View incremented for post ID: ${id}`);
  } catch (error) {
    console.error("Error tracking video view:", error);
  }
};


  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title="Trading Detail" />
      <PageContainer>
        <div className="container xl:p-10 p-5 flex flex-col lg:flex-row 2xl:gap-52 xl:gap-32 lg:gap-22 md:gap-15 sm:gap-10 gap-5 max-sm:border-t border-[#E3EDF6]">
          {loading ? (
            <p className="text-center mt-4">Loading video...</p>
          ) : !video ? (
            <p className="text-center mt-4">Video not found.</p>
          ) : (
            <>
          {/* Main Video Section */}
              <div className="relative xl:min-w-[calc(100%-680px)] lg:min-w-[calc(100%-580px)] min-w-[calc(100%-480px)]">
                <div className="relative sm:mb-7 mb-5">
                  <video
                    ref={videoRef}
                    controls
                    autoPlay
                    onPlay={() => handleVideoView(video.id)}
                    className="w-full h-auto rounded-lg aspect-[16/9] object-contain"
                  >
                    <source src={video.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>

                </div>

                <h2 className="sm:text-2xl text-base font-semibold sm:mb-3.5 mb-3">{video.title}</h2>
                <ul className="flex gap-8 mb-5">
                  <li className="flex items-center text-[#999999] gap-1"> <img src="/Eye.svg" alt="" />{video.views}</li>
                  <li className="flex items-center text-[#999999] gap-1">
                    <img src="/Date.svg" alt="" />
                    {video.created_at ? formatDate(video.created_at) : "N/A"}
                  </li>
                </ul>
                <p className="sm:text-base text-sm text-[#999999]">{video.description}</p>
              </div>
              <div className="xl:min-w-[460px] lg:min-w-[360px] min-w-[260px]">
              </div>
            </>
          )}
        </div>
      </PageContainer>
    </>
  );
};

export default TradingSingle;
